import { render } from "./confirmChangePass.vue?vue&type=template&id=64c4ad8e"
import script from "./confirmChangePass.vue?vue&type=script&lang=js"
export * from "./confirmChangePass.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__